// extracted by mini-css-extract-plugin
export default {"H21":"DocExpiryDate_H21__+MN6j"};